import React, { useEffect, useState } from 'react';
import { Divider, Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { BarcodeScanner } from '@thewirv/react-barcode-scanner';

export default function BarCodeScanner({open, onClose, title = 'Barcode Scanner' }) {

    const handleClose = () => {
        onClose();
    };

    const [chipNumber, setChipNumber] = useState("No result");

    useEffect(() => {
      const video = document.querySelector("video");
      video?.play().catch(err => console.error("Autoplay blocked:", err));
    }, [open]);

    return (
        <React.Fragment>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus slotProps={{ backdrop: { 'aria-hidden': false } }}>
            <DialogTitle>
            {title}
            </DialogTitle>
            <DialogContent
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",     // horizontal centering
                justifyContent: "center", // vertical centering
              }}
            >
              {open && (
                <BarcodeScanner
                  onSuccess={(text) => setChipNumber(text)}
                  constraints={{ facingMode: "environment" }}
                  style={{ width: "100%" }}
                />
              )}
              <p>Microchip Number: {chipNumber}</p>
              <Typography textAlign={'center'} variant='body1'>Barcode Scanner</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}